<template>
  <div class="base warp">
    <inside-header title="帮助中心" />
    <div class="content" style="margin-top:15px;">
      <a-input placeholder="输入你想要搜索的内容" style="background-color:#f5f5f5;" @pressEnter="onSearchChange">
        <a-icon slot="prefix" type="search" />
      </a-input>
    </div>
    <div v-show="searchKey !== ''">
      <div class="search-list">
        <div>搜索结果</div>
        <div class="list">
          <div v-for="(pith, keys) in song" :key="keys" class="item">
            <span @click="goform(pith.id)">{{ pith.title }}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-for="(cate, index) in helpLists" :key="index">
      <div style="margin-top:40px;">
        {{ cate.name }}
      </div>
      <div style="box-shadow: 0 0 10px 0 rgba(216,216,216,0.3);border-radius:10px;">
        <div style="padding:21px 13px 27px 16px;margin-top:15px;">
          <a-collapse default-active-key="1" :bordered="false" expand-icon-position="right"
            style="background-color:#fff;text-decoration:none;">
            <a-collapse-panel v-for="(item, i) in cate.children" :key="i" :header="item.name">
              <!-- <div>{{ item.description }}</div> -->
              <div v-for="(helpItem, j) in helpItem(item.id)" :key="j" @click="goform(helpItem.id)">
                {{ helpItem.title }}
              </div>
            </a-collapse-panel>
          </a-collapse>
        </div>
      </div>
    </div>
    <main-footer />
  </div>
</template>
<script>
import { MainFooter, InsideHeader } from '@/components'

export default {
  name: 'TutorList',
  description: '选课',
  components: {
    MainFooter,
    InsideHeader
  },
  // 初始化变量
  data() {
    return {
      text: '注册时提示手机号码已经被注册时的解决办法',
      text1: '时间起始点——宇宙大爆炸这称的奇点。',
      text2: '上帝是如何启动宇宙的？',
      expandIconPosition: 'right',
      helpLists: [],
      song: [],
      searchKey: '',
      all_list: []
    }
  },
  computed: {
    helpItem() {
      return (cateId) => {
        const allList = this.all_list
        const data = []
        allList.forEach(item => {
          if (item.cate_id === cateId) {
            data.push(item)
          }
        })
        return data
      }
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.$http({
        url: 'index/helps/list',
        method: 'get'
      }).then(res => {
        console.log(res)
        if (res.status === 'success') {
          var data = res.data
          this.helpLists = data.cates
          this.all_list = data.all_list
        } else {
          this.notifacation.error({
            message: '系统繁忙,请刷新重试',
            description: ''
          })
        }
      })
    },
    handleClick(event) {
      // If you don't want click extra trigger collapse, you can prevent this:
      event.stopPropagation()
    },
    onSearchChange(e) {
      console.log(e)
      this.searchKey = e.srcElement.value
      this.search(e.srcElement.value)
    },
    search(e) {
      this.$http({
        url: 'index/helps/search',
        method: 'get',
        params: {
          keywords: e
        }
      }).then(res => {
        console.log(res)
        if (res.status === 'success') {
          var data = res.data
          this.song = data.list
        } else {
          this.notifacation.error({
            message: '系统繁忙,请刷新重试',
            description: ''
          })
        }
      })
    },
    goform(e) {
      this.$router.push({ name: 'HelpItem', params: { id: e } })
    },
    goUserIndex() {
      console.log(12)
      this.$router.push({ name: 'UserIndex' })
    }
  }
}
</script>
<style lang="stylus">
  .warp {
    padding: 0 15px;
  }
  .warp .content input{
      background-color:#f5f5f5;
  }
  .search-list{
    margin-top:20px;
    .list .item{
        padding:5px 5px;
        border-bottom:1px solid #eee;
    }
  }
</style>
